import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LocaleNavLink from 'components/LocaleNavLink';
import StandardContainer from 'components/StandardContainer';
import {
    T_AND_C,
    PRIVACY,
    NEWS_ROOM,
    CONTACT_US,
    LOST_N_FOUND,
    ABOUT_US,
    SERVICE,
    CSR,
    PARTNERSHIPS,
} from 'constants/route';
import appleStoreZhIcon from 'assets/img/icons/ios_badge_ch.svg';
import appleStoreEnIcon from 'assets/img/icons/ios_badge_en.svg';
import googlePlayZhIcon from 'assets/img/icons/android_badge_ch.svg';
import googlePlayEnIcon from 'assets/img/icons/android_badge_en.svg';
import gogoroLogo from 'assets/img/gogoro-logo-small.svg';
import iconFB from 'assets/img/icons/icon-facebook.svg';
import iconInstagram from 'assets/img/icons/icon-instagram.svg';
import iconLinkedin from 'assets/img/icons/icon-linkedin.svg';
import iconMail from 'assets/img/icons/icon-mail.svg';
import './footer.scss';


const Component = ({ dispatch, i18n, match, ghostHeader }) => {
    const { locale } = i18n;
    const { url } = match;
    const isZh = ['zh', 'zh-TW'].indexOf(locale) > -1;
    const appleStoreIcon = (isZh ? appleStoreZhIcon : appleStoreEnIcon);
    const googlePlayIcon = (isZh ? googlePlayZhIcon : googlePlayEnIcon);
    const currentPath = url.replace(/\/[tw|us]\//g, '').split('/').pop();

    return (
        <StandardContainer tag="footer" className="footer" ghostHeader={ ghostHeader }>
            <section className="downloads">
                <img className="icon" src={ appleStoreIcon } alt="app store" />
                <img className="icon" src={ googlePlayIcon } alt="google play" />
            </section>
            <section className="contact">
                <LocaleNavLink to={ ABOUT_US }>
                    <Translate value="nav-about-us" />
                </LocaleNavLink>
                <LocaleNavLink to={ SERVICE }>
                    <Translate value="our-service" />
                </LocaleNavLink>
                <LocaleNavLink to={ PARTNERSHIPS }>
                    <Translate value="nav-partnerships" />
                </LocaleNavLink>
                <LocaleNavLink to={ CONTACT_US }>
                    <Translate value="contact-us" />
                </LocaleNavLink>
                <LocaleNavLink to={ NEWS_ROOM }>
                    <Translate value="newsroom" />
                </LocaleNavLink>
                <a
                    href="https://www.104.com.tw/company/ojonwyo"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                >
                    <Translate value="career" />
                </a>
            </section>
            <section className="icons">
                <a href="mailto:support.tw@ridegoshare.com" className="icon" target="_blank" rel="noopener noreferrer">
                    <img alt="email" className="icon" src={ iconMail } />
                </a>
                <a href="https://www.facebook.com/GoShareTW/" className="icon" target="_blank" rel="noopener noreferrer">
                    <img alt="Facebook" src={ iconFB } />
                </a>
                <a href="https://www.instagram.com/goshare.official" className="icon" target="_blank" rel="noopener noreferrer">
                    <img alt="Instagram" className="icon" src={ iconInstagram } />
                </a>
                <a href="https://www.linkedin.com/company/ridegoshare" className="icon" target="_blank" rel="noopener noreferrer">
                    <img alt="Linkedin" className="icon" src={ iconLinkedin } />
                </a>
            </section>
            <section className="language">
                <a href={ `/tw/${ currentPath }` } className="lang">中文</a>
                <span>|</span>
                <a href={ `/us/${ currentPath }` } className="lang">English</a>
            </section>
            <a
                href={ isZh ? 'https://www.gogoro.com/tw/' : 'https://www.gogoro.com/' }
                className="gogoro-logo"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={ gogoroLogo } alt="gogoro logo" />
            </a>
            <p className="legal">
                <LocaleNavLink to={ PRIVACY } className="link">
                    <Translate value="privacy-policy" />
                </LocaleNavLink>
                <span>|</span>
                <LocaleNavLink to={ T_AND_C } className="link">
                    <Translate value="terms-and-conditions" />
                </LocaleNavLink>
                <span>|</span>
                <LocaleNavLink to={ CSR } className="link">
                    <Translate value="nav-csr" />
                </LocaleNavLink>
                <span>|</span>
                <a
                    href={ isZh ? 'https://www.ridegoshare.jp/tw/' : 'https://www.ridegoshare.jp/en/' }
                    className="link"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Translate value="goshare-jp" />
                </a>
                <span>|</span>
                <LocaleNavLink to={ LOST_N_FOUND } className="link">
                    <Translate value="lost_found" />
                </LocaleNavLink>
            </p>
            <p className="copyright">
                <Translate value="all-rights-reserved" />
            </p>
        </StandardContainer>
    );
};

Component.propTypes = {
    ghostHeader: PropTypes.bool,
};
Component.defaultProps = {
    ghostHeader: true,
};

export default withRouter(connect(state => ({ i18n: state.i18n }))(Component));
